module.exports = __webpack_public_path__ + "629a55a7e793da068dc580d184cc0e31.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/css/fonts/OpenSans-Regular.ttf
 ** module id = 369
 ** module chunks = 0
 **/